<app-fn-ui-navigation-tree class="party-explorer-navigation"
                           [treeConfig]="partyExplorerService.treeConfig"
                           [treeModel]="partyExplorerService.tree.nodes"
                           [selectedNode]="partyExplorerService.activeNode">
</app-fn-ui-navigation-tree>
